var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"columns"},[_c('div',{staticClass:"column is-6 is-offset-3"},[_c('div',[_c('div',{staticClass:"box_image"},[_vm._t("image")],2),_vm._v(" "),_c('div',{staticClass:"box_text"},[_vm._t("body",[_vm._v("Algo anduvo mal")])],2)])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-23c94f9b","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/shared/Notification.vue
// module id = 58
// module chunks = 0